var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_banner"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.onload),expression:"onload"}],attrs:{"src":_vm.mainImgOnload}})])}
var staticRenderFns = []

export { render, staticRenderFns }